import { Component } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CreateQuickCustomerLookupComponent } from '../create-quick-customer-lookup/create-quick-customer-lookup.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-close-quick-customer-lookup',
  standalone: true,
  imports: [SharedModule, CreateQuickCustomerLookupComponent],
  templateUrl: './close-quick-customer-lookup.component.html',
  styleUrl: './close-quick-customer-lookup.component.scss'
})
export class CloseQuickCustomerLookupComponent {

  constructor(public ref: DynamicDialogRef){}

  close(data: any){
    this.ref.close(data);
  }
  
}
